export default {
	TABLE_TITLE: 'Grids',
	GRID_ADDED: 'Grid added',
	GRID_EDITED: 'Grid edited',
	GRID_DELETED: 'Grid deleted',
	DETAILS_TOOLTIP: 'Go to grid entries',
};
